//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.AMEBaseBuilder.js";
import "../no/ugmath.js";
import "../no/Diagramming.js";
let d=[[],[[["shieldVariant"],"SetShieldVariant",{},1,0],[["point"],"SetShieldLocation",{},1,0],[["pageObject"],"CreateShieldNode",{R_:{nodeObject:"Diagramming.Node"}},1,0]],[]];
SPLM.AME.ShieldBuilder = class extends SPLM.AME.AMEBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.ShieldBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.ShieldBuilder.Variant = Object.freeze({
    "H" : "H", "V" : "V"});

export default SPLM;